import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiShield } from 'react-icons/fi';

const UrgencySection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openQuiz = () => {
    window.open('https://www.wethebillions.com/quiz', '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-accent-magenta text-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-12"
          >
            <div className="w-16 h-16 bg-accent-gold/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiClock} className="h-8 w-8 text-accent-gold" />
            </div>
            <h2 className="text-3xl lg:text-4xl font-playfair font-bold mb-6">
              Every Year of Struggle is a Year Your Child Spends Falling Behind Their Potential.
            </h2>
          </motion.div>

          {/* Body */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-4xl mx-auto space-y-6 mb-12"
          >
            <p className="text-xl text-gray-200 leading-relaxed">
              The brain has a remarkable capacity to change, especially in childhood. But with each passing year, the academic gap widens, and the emotional toll deepens.
            </p>
            <p className="text-2xl font-semibold text-white">
              Don't just manage symptoms. Change the trajectory.
            </p>
            <div className="flex items-center justify-center gap-3 text-accent-gold">
              <SafeIcon icon={FiShield} className="h-6 w-6" />
              <span className="text-lg font-medium">
                We guarantee measurable growth because we know the science works.
              </span>
            </div>
          </motion.div>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="space-y-6"
          >
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={scrollToContact} className="btn-gold text-lg px-10 py-5">
                Book Your Cognitive Consultation
              </button>
              <button 
                onClick={openQuiz}
                className="border-2 border-white text-white px-10 py-5 rounded-full font-semibold hover:bg-white hover:text-gray-900 transition-all duration-200"
              >
                Take the FREE Quiz
              </button>
            </div>
            
            {/* Contact Info */}
            <div className="pt-8 border-t border-gray-600">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div>
                  <div className="text-accent-gold font-semibold mb-1">📧 Email</div>
                  <a href="mailto:hello@wethebillions.com" className="text-gray-300 hover:text-white transition-colors">
                    hello@wethebillions.com
                  </a>
                </div>
                <div>
                  <div className="text-accent-gold font-semibold mb-1">📞 Call/Text</div>
                  <a href="tel:+12026560054" className="text-gray-300 hover:text-white transition-colors">
                    (202) 656-0054
                  </a>
                </div>
                <div>
                  <div className="text-accent-gold font-semibold mb-1">🗓️ Book Online</div>
                  <a href="https://wethebillions.neetocal.com/consultation" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                    wethebillions.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default UrgencySection;